/* ==========================================================================
 *  Function: Add navingation scroll
 * ======================================================================= */

var windowScrollTop;
var windowWidth;

var profileTop;
var profileprofileHeightTop;

var hologramOffset;
var hologramTop;
var hologramShow = false;

var aboutTop;
var aboutOffset;
var aboutShow = false;

var partnersTop;
var partnersOffset;
var partnersShow = false;

if ($('#meeting-bar').length){
	var meetingBar = $('#meeting-bar');
}

if ($('.navigation').length){
	var navigation = $('.navigation');
}

if ($('#hologram-section').length){
	var hologramSection = $('#hologram-section');
}

if ($('#about-section').length){
	var aboutSection = $('#about-section');
}

if ($('#trust-us-section').length){
	var partnersSection = $('#trust-us-section');
}

if ($('#btn-fixed').length){
	var btnFixed = $('#btn-fixed');
	var footer = $('.footer');
}

function fn_parts_navigation_scroll_resize(){
	windowScrollTop = $(window).scrollTop();
	windowWidth = $(window).width();

	if ($('.navigation').length){
		if (windowScrollTop > 1 && windowWidth > bp_small) {
			navigation.addClass( 'navigation-scroll' );
		} else {
			navigation.removeClass( 'navigation-scroll' );
		}
	}

	if ($('#meeting-bar').length && windowWidth < bp_medium){
		profileTop = $('.main-content-profile').offset().top;
		profileHeight = $('.main-content-profile').outerHeight();

		if ((windowScrollTop > profileTop - 60 ) && (windowScrollTop < profileHeight - 60) ) {
			meetingBar.addClass( class_active );
		} else {
			meetingBar.removeClass( class_active );
		}
	}

	if ($('#btn-fixed').length && windowWidth < bp_medium){
		footerOffsetTop = footer.offset().top;

		if (windowScrollTop + $window.height() + 70 > footerOffsetTop ) {
			btnFixed.removeClass( class_active );
		} else {
			btnFixed.addClass( class_active );
		}

	}

	if ($('#hologram-section').length && windowWidth > bp_small && !hologramShow){
		if (windowWidth > 1200 ){
			hologramOffset = 400;
		} else {
			hologramOffset = 200;
		}
		hologramTop = hologramSection.offset().top - hologramOffset;
		if (windowScrollTop > hologramTop  ) {
			$('.js-hologram-item').addClass( 'is-animated' );
			hologramShow = true;
		}
	}

	if ($('#about-section').length && windowWidth > bp_small && !aboutShow){
		if (windowWidth > 1200 ){
			aboutOffset = 400;
		} else {
			aboutOffset = 200;
		}
		aboutTop = aboutSection.offset().top - aboutOffset;
		if (windowScrollTop > aboutTop  ) {
			$('.benefits-item').addClass( 'is-animated' );
			aboutShow = true;
		}
	}

	if ($('#trust-us-section').length && windowWidth > bp_small && !partnersShow){
		if (windowWidth > 1200 ){
			partnersOffset = 400;
		} else {
			partnersOffset = 200;
		}
		partnersTop = partnersSection.offset().top - partnersOffset;
		if (windowScrollTop > partnersTop  ) {
			$('#trust-us-section').addClass( 'is-animated' );
			partnersShow = true;
		}
	}
}
